import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { SubTitle } from "./SubTitle";
import { SideMenuTreeProps } from "./types";
import MenuTree from "../MenuTree/MenuTree";
import { Sidebar } from "../Sidebar";
import React, { useEffect  } from "react";

export const DEFAULT_SIDEBAR_WIDTH = "340px";

const SideMenuTree = ({
  homeItemProps,
  isSidebarOpen,
  onCloseSidebar,
  placeholderText,
  ...props
}: SideMenuTreeProps) => {

  useEffect(() => {
    const treeItemOpened = Array.from(document.querySelectorAll('[data-isopen="true"]')).at(-1)
    if (isSidebarOpen && treeItemOpened) {
      treeItemOpened.scrollIntoView({block: "center"})
  }}, [isSidebarOpen])

  return (
    <Sidebar
      isSidebarOpen={isSidebarOpen}
      onCloseSidebar={onCloseSidebar}
      maxWidth={DEFAULT_SIDEBAR_WIDTH}
    >
      <MenuTree
        {...props}
        customComponent={
          homeItemProps ? (
            <SubTitle
              icon={<HomeOutlinedIcon />}
              text={homeItemProps?.text ?? "Home"}
              onClickHandler={() => location.assign("/")}
            />
          ) : undefined
        }
        placeholderText={placeholderText}
      />
    </Sidebar>
  );
};

export default SideMenuTree;
